module.exports = __webpack_public_path__ + "static/media/male.295bf768.m4a";